import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface MarketSizeSectionProps {
  potentialCustomers: string;
  setPotentialCustomers: (value: string) => void;
  revenuePerCustomer: string;
  setRevenuePerCustomer: (value: string) => void;
}

export const MarketSizeSection = ({
  potentialCustomers,
  setPotentialCustomers,
  revenuePerCustomer,
  setRevenuePerCustomer,
}: MarketSizeSectionProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label className="flex items-center">
          Number of Potential Customers
          <span className="text-red-500 ml-1">*</span>
        </Label>
        <Input
          type="number"
          value={potentialCustomers}
          onChange={(e) => setPotentialCustomers(e.target.value)}
          placeholder="e.g., 1000000"
        />
      </div>

      <div>
        <Label className="flex items-center">
          Revenue per Customer (per year)
          <span className="text-red-500 ml-1">*</span>
        </Label>
        <Input
          type="number"
          value={revenuePerCustomer}
          onChange={(e) => setRevenuePerCustomer(e.target.value)}
          placeholder="e.g., 100"
        />
      </div>
    </div>
  );
};